import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "blueStep1 col-12 mb-4" };
const _hoisted_2 = { class: "col-12 bg-white border rounded pt-3 [ JS_blueStep1ContentWrapper ]" };
const _hoisted_3 = { class: "shippingAddressWrapper" };
const _hoisted_4 = { class: "col-12 pt-3" };
const _hoisted_5 = { class: "col-12 m-0 p-0 mt-3" };
const _hoisted_6 = { class: "col-12 pt-1 px-0 mb-3 ml-n1" };
const _hoisted_7 = {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    class: "strong font7",
    "data-original-title": "myPOINTS werden Dir nach Ablauf der Rückgabefrist gutgeschrieben\n                            (sofern Du die Bestellung nicht stornierst oder retournierst) und können gegen Gutscheine\n                            eingetauscht werden."
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "col-12 px-0 mb-n2" };
const _hoisted_10 = { class: "col-12 border-top pt-3 pb-3 px-0" };
const _hoisted_11 = {
    key: 0,
    class: "billingAddressWrapper fade-in"
};
const _hoisted_12 = { class: "col-12 pt-2 mb-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_email_input = _resolveComponent("base-email-input");
    const _component_switch_toggle = _resolveComponent("switch-toggle");
    const _component_base_password_input = _resolveComponent("base-password-input");
    const _component_address_form = _resolveComponent("address-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row border-bottom" }, [
                    _createElementVNode("div", { class: "col-12" }, [
                        _createElementVNode("div", { class: "font7 mb-2" }, "Schritt 1 von 3"),
                        _createElementVNode("h2", { class: "h5 mb-3" }, "Lieferadresse")
                    ])
                ], -1)),
                (_ctx.current_shipping_address)
                    ? (_openBlock(), _createBlock(_component_address_form, {
                        key: 0,
                        id: "shipping_address_form",
                        class: "no-gutters",
                        modelValue: _ctx.current_shipping_address,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.current_shipping_address) = $event)),
                        onFinishChange: _ctx.autoFinishShippingAddress,
                        onChange: _ctx.resetValidCartState,
                        errors: _ctx.shippingAddressErrors
                    }, _createSlots({
                        beforeAddressForm: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                (_ctx.isLogin)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "font8-responsive link-gray",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.saveShippingAddress(true)))
                                    }, [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("i", {
                                                class: "icon-install",
                                                style: { "cursor": "pointer" }
                                            }, null, -1),
                                            _createTextVNode(" Adresse als Standard speichern ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                (!_ctx.isLogin)
                                    ? (_openBlock(), _createBlock(_component_base_email_input, {
                                        key: 0,
                                        id: "email",
                                        name: "email",
                                        placeholder: "E-Mail",
                                        modelValue: _ctx.current_email,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.current_email) = $event)),
                                        onBlur: _ctx.saveEmail,
                                        required: true,
                                        errors: _ctx.emailError
                                    }, null, 8, ["modelValue", "onBlur", "errors"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 2
                    }, [
                        (!_ctx.isLogin)
                            ? {
                                name: "afterName",
                                fn: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_component_switch_toggle, {
                                            id: "show_password_field",
                                            name: "show_password",
                                            title: "",
                                            modelValue: _ctx.shouldRegister,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.shouldRegister) = $event)),
                                            style: { "width": "auto", "display": "inline-block" }
                                        }, null, 8, ["modelValue"]),
                                        _createElementVNode("div", {
                                            class: "font7-responsive",
                                            style: { "float": "right", "width": "calc(100% - 53px)", "cursor": "pointer" },
                                            onClick: _cache[3] || (_cache[3] =
                                                //@ts-ignore
                                                (...args) => (_ctx.togglePasswordFieldToRegisterAccount && _ctx.togglePasswordFieldToRegisterAccount(...args)))
                                        }, [
                                            _cache[12] || (_cache[12] = _createTextVNode(" Ich möchte ein Nutzerkonto erstellen und mit dieser Bestellung ", -1)),
                                            _cache[13] || (_cache[13] = _createElementVNode("br", { class: "d-xl-inline-block d-none" }, null, -1)),
                                            _createElementVNode("span", _hoisted_7, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.cartTotals.my_points), 1),
                                                _cache[10] || (_cache[10] = _createTextVNode(" myPOINTS ", -1)),
                                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icon-ankaufbedingungen" }, null, -1))
                                            ]),
                                            _cache[14] || (_cache[14] = _createTextVNode(" sammeln ", -1))
                                        ])
                                    ]),
                                    (_ctx.shouldRegister)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createVNode(_component_base_password_input, {
                                                    id: "new_password",
                                                    name: "password",
                                                    modelValue: _ctx.guest_password,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.guest_password) = $event)),
                                                    title: "",
                                                    onChanged: _ctx.saveValidGuestPassword
                                                }, null, 8, ["modelValue", "onChanged"])
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-12 mb-4 px-0 font8-responsive fc-gray border-bottom pb-2" }, [
                                                _createTextVNode(" Mit der Registrierung erklärst du dich mit den "),
                                                _createElementVNode("a", {
                                                    href: "/agb",
                                                    title: "Zu den AGB's",
                                                    target: "_blank",
                                                    class: "link-in-text"
                                                }, "AGB"),
                                                _createTextVNode(" und "),
                                                _createElementVNode("a", {
                                                    href: "/datenschutz",
                                                    target: "_blank",
                                                    title: "Zu den AGB's",
                                                    class: "link-in-text"
                                                }, " Datenschutzbestimmungen "),
                                                _createTextVNode(" der "),
                                                _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                                                _createTextVNode(" GmbH einverstanden. ")
                                            ], -1))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                key: "0"
                            }
                            : undefined
                    ]), 1032, ["modelValue", "onFinishChange", "onChange", "errors"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_switch_toggle, {
                        id: "show_billing_address",
                        name: "show_billing",
                        title: "Abweichende Rechnungsadresse angeben",
                        modelValue: _ctx.use_billing_address,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.use_billing_address) = $event)),
                        onChange: _ctx.changeShowBillingAddress,
                        errors: _ctx.billingAddressErrors
                    }, null, 8, ["modelValue", "onChange", "errors"])
                ])
            ]),
            (_ctx.use_billing_address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row border-top pt-4" }, [
                        _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("h2", { class: "h5 strong mb-2" }, "Rechnungsadresse")
                        ])
                    ], -1)),
                    (_ctx.use_billing_address && _ctx.current_billing_address)
                        ? (_openBlock(), _createBlock(_component_address_form, {
                            key: 0,
                            id: "billing_address_form",
                            class: "no-gutters",
                            modelValue: _ctx.current_billing_address,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.current_billing_address) = $event)),
                            onFinishChange: _ctx.autoFinishBillingAddress,
                            onChange: _ctx.resetValidCartState
                        }, _createSlots({ _: 2 }, [
                            (_ctx.isLogin)
                                ? {
                                    name: "beforeAddressForm",
                                    fn: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", {
                                                class: "font8-responsive link-gray",
                                                onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.saveBillingAddress(true)))
                                            }, [...(_cache[17] || (_cache[17] = [
                                                    _createElementVNode("i", {
                                                        class: "icon-install",
                                                        style: { "cursor": "pointer" }
                                                    }, null, -1),
                                                    _createTextVNode(" Adresse als Standard speichern ", -1)
                                                ]))])
                                        ])
                                    ]),
                                    key: "0"
                                }
                                : undefined
                        ]), 1032, ["modelValue", "onFinishChange", "onChange"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
